import {Box, Button, Text} from "@chakra-ui/react";
import {FormattedMessage} from "react-intl";
import React from "react";
import {useNavigate} from "react-router-dom";

const CallToLoginView = () => {
  const navigate = useNavigate();

  return (
    <Box
      position={"relative"}
      padding={6}
      display="flex"
      flexDirection={"column"}
      flex={"1 1 auto"}
    >
      <Text
        px={1}
        fontWeight={"normal"}
        lineHeight={1.5}
        textAlign={"center"}
      >
        <FormattedMessage
          id="login-and-follow-your-progress"
          defaultMessage={
            "Connecte-toi pour profiter d’une expérience personnalisé et suivre ta progression"
          }
        />
      </Text>
      <Button
        variant={"solid"}
        width={"250px"}
        bg="cyan.550"
        color="white"
        boxShadow="0px 4px 0 0 #3398a4"
        maxWidth="100%"
        minHeight="56px"
        py={4}
        px={10}
        mx={"auto"}
        mt={4}
        sx={{
          "&:hover": {
            bg: "#6bc1cb",
          },
          "&:hover[disabled]": {
            bg: "#6bc1cb",
          },
          "&:focus": {
            boxShadow: "var(--chakra-shadows-outline)",
          },
        }}
        onClick={() => navigate("/", { replace: true, state: { instantLogin: true } })}
      >
        <FormattedMessage id="login" defaultMessage={"Se connecter"} />
      </Button>
      <Button
        variant={"solid"}
        maxWidth="100%"
        sx={{
          bg: "#f5f3ef",
          color: "black",
          "&:hover": {
            bg: "#efefef",
          },
          width: "250px",
          height: "56px",
          mt: "5",
          mx: "auto",
          fontWeight: "500",
        }}
        onClick={() => navigate("/", { replace: true, state: { instantRegister: true } })}
      >
        <FormattedMessage
          id="create-account"
          defaultMessage={"Créer mon compte"}
        />
      </Button>
    </Box>
  )
}

export default CallToLoginView;